<div class="main-view space-y-4 md:space-y-6">
  <app-page-surface-header
    titleIcon="checks"
    title="Rule packs & compliance"
    subtitle="Activate and manage versioned rule packages per client, product, and country."
  />

  <p *ngIf="pageLoading" class="text-sm text-gray-500 dark:text-gray-400">Loading clients, products and packs…</p>
  <p *ngIf="pageError" class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800 dark:border-red-900/50 dark:bg-red-950/40 dark:text-red-100" role="alert">
    {{ pageError }}
  </p>

  <ng-container *ngIf="!pageLoading && !pageError">
    <!-- Scope bar -->
    <div class="rounded-3xl border border-gray-200/80 bg-white/40 p-4 shadow-sm dark:border-[#191e3a] dark:bg-dark/10 md:p-6">
      <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <div>
          <label for="rulePackTenant" class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Client</label>
          <select id="rulePackTenant" name="rulePackTenant" class="form-select w-full rounded-xl border-gray-200 bg-white dark:border-[#191e3a] dark:bg-[#0e1726]" [(ngModel)]="selectedTenantId" (ngModelChange)="onTenantChange()">
            <option [ngValue]="null">Select client…</option>
            <option *ngFor="let t of tenants" [ngValue]="t.id">{{ t.label }}</option>
          </select>
        </div>
        <div>
          <label for="rulePackProduct" class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Product</label>
          <select id="rulePackProduct" name="rulePackProduct" class="form-select w-full rounded-xl border-gray-200 bg-white dark:border-[#191e3a] dark:bg-[#0e1726]" [(ngModel)]="selectedProductId" (ngModelChange)="onScopeChange()">
            <option [ngValue]="null">Select product…</option>
            <option *ngFor="let p of products" [ngValue]="p.id">{{ p.label }}</option>
          </select>
        </div>
        <div>
          <label for="rulePackCountry" class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Country pack</label>
          <select id="rulePackCountry" name="rulePackCountry" class="form-select w-full rounded-xl border-gray-200 bg-white dark:border-[#191e3a] dark:bg-[#0e1726]" [(ngModel)]="selectedCountry" (ngModelChange)="onScopeChange()">
            <option value="">— Select —</option>
            <option *ngFor="let c of countryPacks" [value]="c.code">{{ c.name }}</option>
          </select>
        </div>
      </div>

      <div class="mt-6 flex flex-wrap items-center gap-3">
        <button type="button" class="btn inline-flex items-center gap-2 rounded-full bg-[#303030] px-5 py-2.5 text-sm font-medium text-white hover:bg-black disabled:opacity-50" [disabled]="!canAct || actionBusy" (click)="activate()">
          <span *ngIf="actionBusy" class="inline-block size-4 animate-spin rounded-full border-2 border-white/30 border-t-white"></span>
          Activate country pack
        </button>
        <button type="button" class="btn inline-flex items-center gap-2 rounded-full border px-5 py-2.5 text-sm font-medium disabled:opacity-50" [disabled]="!canAct" (click)="openEditor()">Edit values</button>
      </div>

      <p *ngIf="actionMessage" class="mt-4 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-900 dark:border-emerald-900/40 dark:bg-emerald-950/30 dark:text-emerald-100">{{ actionMessage }}</p>
      <p *ngIf="actionError" class="mt-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800 dark:border-red-900/50 dark:bg-red-950/40 dark:text-red-100" role="alert">{{ actionError }}</p>
    </div>

    <ng-container *ngIf="canAct">
      <app-active-package-panel
        [active]="active"
        [lockedKeys]="lockedKeys"
        [loading]="activeLoading"
        [empty]="activeEmpty"
        [refreshing]="activeRefreshing"
        (refresh)="refreshActive()"
      ></app-active-package-panel>

      <app-version-history-table
        [versions]="versions"
        [activeVersionId]="active?.version_id ?? null"
        [total]="versionsTotal"
        [page]="versionsPage"
        [pageSize]="versionsPageSize"
        [loading]="versionsLoading"
        [busyId]="rowBusyId"
        (view)="openDetail($event)"
        (publish)="askPublish($event)"
        (restore)="askRestore($event)"
        (pageChange)="loadVersions($event)"
      ></app-version-history-table>

      <app-compliance-locks-panel [locks]="locks" [countryCode]="selectedCountry" [loading]="locksLoading"></app-compliance-locks-panel>
    </ng-container>
  </ng-container>

  <app-version-detail-modal
    [open]="detailOpen"
    [version]="detailVersion"
    [lockedKeys]="lockedKeys"
    [preview]="preview"
    [validating]="validating"
    (close)="closeDetail()"
    (validate)="validateVersion($event)"
  ></app-version-detail-modal>

  <app-restore-confirm-modal
    [open]="restoreOpen"
    heading="Restore this version?"
    [entityName]="restoreTarget ? 'v' + restoreTarget.version_seq : ''"
    activeListLabel="draft list"
    [loading]="restoreBusy"
    (cancelled)="cancelRestore()"
    (confirmed)="confirmRestore()"
  ></app-restore-confirm-modal>

  <!-- Publish confirm (reuses restore-confirm-modal styling/contract) -->
  <app-restore-confirm-modal
    [open]="publishOpen"
    heading="Publish this version?"
    [entityName]="publishTarget ? 'v' + publishTarget.version_seq : ''"
    activeListLabel="active package for new sessions"
    [loading]="publishBusy"
    (cancelled)="cancelPublish()"
    (confirmed)="confirmPublish()"
  ></app-restore-confirm-modal>
</div>
